/*
  Footer link menu accordion.

  The accordion only exists below 750px. Above it the menus are columns and the
  stylesheet makes the summary non-interactive, so there is no control left to
  reopen one that the visitor collapsed on a narrow viewport. A menu closed on a
  phone would then still be closed on a desktop, with its links unreachable and
  no way to get them back.

  So the element does one thing: force the details open whenever the viewport is
  wide enough to be showing columns. Everything else - the toggle, the keyboard
  handling, the expanded state announced to a screen reader - is details and
  summary doing their own job, which is why they were used instead of a div and
  a click handler.
*/
class FooterAccordion extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    if (!this.details) return;

    this.query = window.matchMedia('(min-width: 750px)');
    this.onChange = () => {
      if (this.query.matches) this.details.open = true;
    };

    this.query.addEventListener('change', this.onChange);
    this.onChange();
  }

  disconnectedCallback() {
    this.query?.removeEventListener('change', this.onChange);
  }
}

customElements.define('footer-accordion', FooterAccordion);
